var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "expiry_pending",
      class: { "pd-10": _vm.type == "single", "pd-tp-0": _vm.name },
      on: { scroll: _vm.deactivatePopover },
    },
    [
      _c("h3", [
        _c(
          "span",
          {
            staticClass: "cursor-pointer",
            on: {
              click: function ($event) {
                return _vm.goToLink("/layout/registration", "pending")
              },
            },
          },
          [
            _c("img", {
              staticClass: "dashboard-icons",
              attrs: {
                src: "/static/images/icons/track_plus_icon_blue.svg",
                alt: "trackplus-icon",
              },
            }),
            _vm._v("Pending"),
          ]
        ),
      ]),
      _c(
        "div",
        { staticClass: "MT-25" },
        _vm._l(_vm.pending_summary, function (item, key, index) {
          return _c("div", { key: index }, [
            _c(
              "p",
              { staticClass: "tab_expiry" },
              [
                key === "initial"
                  ? _c("span", [_vm._v("Initial Registrations")])
                  : _vm._e(),
                key === "modification"
                  ? _c("span", [_vm._v("Modifications")])
                  : _vm._e(),
                key === "renewal" ? _c("span", [_vm._v("Renewals")]) : _vm._e(),
                item.products && item.products.length > 0
                  ? _c(
                      "el-popover",
                      {
                        attrs: {
                          placement: "bottom",
                          "popper-class": "popper-custom-class",
                          trigger: "hover",
                          width: "200",
                          disabled: _vm.openPopover,
                        },
                        on: { hide: _vm.hidePopover },
                        model: {
                          value: _vm.pendingVisible[index],
                          callback: function ($$v) {
                            _vm.$set(_vm.pendingVisible, index, $$v)
                          },
                          expression: "pendingVisible[index]",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "popper-height" },
                          _vm._l(item.products, function (penReg, index) {
                            return _c(
                              "p",
                              {
                                key: index,
                                staticClass: "cursor-pointer",
                                on: {
                                  click: function ($event) {
                                    return _vm.viewRegistration(
                                      penReg.rid,
                                      "pending",
                                      index
                                    )
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(penReg.name) + " ")]
                            )
                          }),
                          0
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "progress_count cursor-pointer",
                            attrs: { slot: "reference" },
                            on: { click: _vm.activatePopover },
                            slot: "reference",
                          },
                          [_vm._v(_vm._s(item.number))]
                        ),
                      ]
                    )
                  : _vm._e(),
                item.products.length === 0
                  ? _c("span", { staticClass: "progress_count" }, [
                      _vm._v(_vm._s(item.number)),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _c("div", { staticClass: "progress" }, [
              _c("div", {
                staticClass: "progress-bar",
                class: {
                  green: key === "initial",
                  orange: key === "modification",
                  blue: key === "renewal",
                },
                style: { width: item.number + "%" },
                attrs: {
                  "aria-valuenow": item.number,
                  "aria-valuemin": 0,
                  "aria-valuemax": 100,
                },
              }),
            ]),
          ])
        }),
        0
      ),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
      _vm.dashboardRecordsFlag
        ? _c("registration-details-popup", {
            attrs: {
              dashboardRecordsFlag: _vm.dashboardRecordsFlag,
              permissions: _vm.permissions,
              dataRow: _vm.activeRegistration,
              reportFlag: true,
            },
            on: {
              dashboardWidgets: _vm.dashboardWidgets,
              hidePopup: _vm.hidePopup,
            },
          })
        : _vm._e(),
      _c("permission-access-modal"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }